export default {
  "status-tag": "_status-tag_180mzk",
  "green": "_green_180mzk",
  "red": "_red_180mzk",
  "purple": "_purple_180mzk",
  "orange": "_orange_180mzk",
  "gray": "_gray_180mzk"
};